export const blogSection = () => {
  const url = window.location.href;
  const array = url.split("/");

  const lastSegment = array[array.length - 1];
  const tags = document.querySelectorAll("ul.tag-block li a.tags");

  for (let i = 0; i < tags.length; i++) {
    if (tags[i].dataset.tag == lastSegment) {
      tags[i].classList.add("bg-black");
      tags[i].classList.remove("bg-white", "text-black");
    } else {
      tags[i].classList.add("bg-white", "text-black");
      tags[i].classList.remove("bg-black");
    }
  }
};

export default blogSection;
